import createAPI from "@/libs/api"
import { TVSlide } from "@/types/tv-slide"

const createTVSlidesAPI = () => createAPI<TVSlide[]>("/tv-slides")
export const createTVSlideAPI = () => createAPI<null, TVSlide>("/tv-slide")

export default createTVSlidesAPI
